import { useEffect, useRef } from 'react';
var useOuterClick = function (callback) {
    var innerRef = useRef(null);
    useEffect(function () {
        var handleClick = function (e) {
            if (innerRef.current && !innerRef.current.contains(e.target)) {
                callback(e);
            }
        };
        document.addEventListener('click', handleClick);
        return function () { return document.removeEventListener('click', handleClick); };
    }, [innerRef, callback]);
    return innerRef;
};
export default useOuterClick;
//# sourceMappingURL=useOutSideClick.js.map